import { Amplify } from 'aws-amplify';

const baseUrls = [
  'http://localhost:3000',
  'https://app-dev.clariumhealth.com',
  'https://app-staging.clariumhealth.com',
  'https://app-qa.clariumhealth.com',
  'https://app-demo.clariumhealth.com',
  'https://app.clariumhealth.com',
];

const redirectSignInUrls = baseUrls.map((url) => `${url}/login/callback`);
const redirectSignOutUrls: Array<string> = [];

Amplify.configure({
  Auth: {
    Cognito: {
      identityPoolId: process.env.VITE_AWS_COGNITO_IDENTITY_POOL!,
      userPoolId: process.env.VITE_COGNITO_USER_POOL_ID!,
      userPoolClientId: process.env.VITE_COGNITO_USER_POOL_WEB_CLIENT_ID!,
      allowGuestAccess: true,
      loginWith: {
        email: true,
        oauth: {
          domain: process.env.VITE_COGNITO_DOMAIN!,
          scopes: ['email', 'openid', 'profile'],
          redirectSignIn: redirectSignInUrls,
          redirectSignOut: redirectSignOutUrls,
          responseType: 'code',
        },
      },
    },
  },
  Storage: {
    S3: {
      bucket: `${process.env.VITE_AWS_BUCKET}`, //REQUIRED -  Amazon S3 bucket name
      region: process.env.VITE_AWS_REGION, //OPTIONAL -  Amazon service region
    },
  },
});
